import { render, staticRenderFns } from "./rentcosttip.vue?vue&type=template&id=5c2e2bd8&scoped=true&"
import script from "./rentcosttip.vue?vue&type=script&lang=js&"
export * from "./rentcosttip.vue?vue&type=script&lang=js&"
import style0 from "./rentcosttip.vue?vue&type=style&index=0&id=5c2e2bd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e2bd8",
  null
  
)

export default component.exports